"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var ListSubheader_1 = __importDefault(require("@material-ui/core/ListSubheader"));
var styles_1 = require("@material-ui/core/styles");
var icons_1 = require("@epic-ui/icons");
var styles = function (_a) {
    var palette = _a.palette;
    return styles_1.createStyles({
        root: {
            display: "flex",
            justifyContent: "flex-end",
            backgroundColor: palette.background.paper,
        },
    });
};
exports.CloseOptionsMenu = styles_1.withStyles(styles, {
    name: "EuiCloseOptionsMenu",
})(React.forwardRef(function CloseItem(_a, ref) {
    var IconButtonProps = _a.IconButtonProps, props = __rest(_a, ["IconButtonProps"]);
    return (React.createElement(ListSubheader_1.default, __assign({ disableGutters: true }, props, { ref: ref }),
        React.createElement(IconButton_1.default, __assign({ size: "small", "aria-hidden": "true" }, IconButtonProps),
            React.createElement(icons_1.More, null))));
}));
//# sourceMappingURL=CloseOptionsMenu.js.map